import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconSchool } from "@tabler/icons-react";

import { useScreen } from "Screen/ScreenContext";
import CreateCommunityModal from "@components/_modals/Community/CreateCommunityModal";

import useAttachCommunity from "./hooks/useAttachCommunity";
import AttachCommunityView from "./view";

/**
 * Creator — attach community controller (§6.10). Route: mentoring/:enrollmentId/
 * attach. Publishes the breadcrumb (Minhas mentorias › {program} › Vincular
 * comunidade), renders the view, and hosts the "Criar nova comunidade" modal —
 * with redirectOnSuccess disabled so creating a community keeps the user here
 * (the new community is auto-selected once the list refreshes).
 */
export default function MentoringAttach() {
  const { enrollmentId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation("member");
  const { setBreadcrumb } = useScreen();

  const attach = useAttachCommunity(enrollmentId);
  const programName = attach.enrollment?.program?.name;

  useEffect(() => {
    document.title = t("attach.documentTitle");
    setBreadcrumb([
      { label: t("myMentorings.breadcrumb"), href: "/mentoring", icon: <IconSchool size={18} /> },
      { label: programName ?? t("mentoringDetail.fallbackName"), href: `/mentoring/${enrollmentId}` },
      { label: t("attach.breadcrumb") },
    ]);
    return () => setBreadcrumb(null);
  }, [setBreadcrumb, programName, enrollmentId, t]);

  function handleOpenDetail() {
    navigate(`/mentoring/${enrollmentId}`);
  }

  return (
    <>
      <AttachCommunityView {...attach} onOpenDetail={handleOpenDetail} />

      <CreateCommunityModal
        open={attach.createOpen}
        onClose={attach.closeCreate}
        onSuccess={attach.onCommunityCreated}
        redirectOnSuccess={false}
      />
    </>
  );
}
